import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

import CruisePlanMap from "./CruisePlanMap"

const CruisePlanMapModal = ({
  isOpen,
  onClose,
  stops,
  cruisePlanId,
  cruisePlanName,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="extraLarge">
      <Modal.Header title={`${cruisePlanName} Map`} />
      <Modal.Body>
        <div className="h-[80vh]">
          <CruisePlanMap stops={stops} cruisePlanId={cruisePlanId} />
        </div>
      </Modal.Body>
    </Modal>
  )
}

CruisePlanMapModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  cruisePlanName: PropTypes.string.isRequired,
  cruisePlanId: PropTypes.string.isRequired,
  stops: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      note: PropTypes.string,
    })
  ).isRequired,
}

export default CruisePlanMapModal
